export const STAKING_DURATION_OPTIONS = [
  { label: "180天", value: 180 },
  { label: "360天", value: 360 },
];

/** 未从链接获取上级地址时使用的默认上级 */
export const DEFAULT_PARENT_ADDRESS =
  "0xd7755bbE049f4cc7b7339Ec7491c72EaB35D2Ed2";

export const EMPTY_PERSONAL_INFO = {
  goldCards: 0,
  silverCards: 0,
  bronzeCards: 0,
  cardReward: "0 RUSD",
  directReferrals: 0,
  directPerformance: "0 USDT",
  totalPerformance: "0 USDT",
  promotionReward: "0 RUSD",
  withdrawnStaking: "0 RUSD",
  withdrawnPromotion: "0 RUSD",
  withdrawnCard: "0 RUSD",
};

/** 持卡用户展示信息（按最高等级卡牌） */
export const CARD_USER_PROFILE = {
  gold: {
    title: "尊敬的金卡用户",
    bonusRange: "1%+0.5%",
    avatarSrc: require("@/assets/image/rad_card2.png"),
  },
  silver: {
    title: "尊敬的银卡用户",
    bonusRange: "1%+0.3%",
    avatarSrc: require("@/assets/image/rad_card1.png"),
  },
  bronze: {
    title: "尊敬的铜卡用户",
    bonusRange: "1%+0.1%",
    avatarSrc: require("@/assets/image/rad_card3.png"),
  },
};
